import http from "../plugins/Axios";
import { makerPagination } from "@/utils/pureFunctions";

export default {
  actions: {
    async getSuppliers(_, query) {
      try {
        let params = query || {};
        let {
          data: { data, total, permissions },
        } = await http.get("supplier/list", {
          params,
        });
        return {
          data: data.map((item, index) => {
            if (query && query.limit && query.page >= 0) {
              item.index = item.index = index + 1 + query.page * query.limit;
            }
            return item;
          }),
          lastPage:
            (query &&
              query.limit &&
              makerPagination({ limit: query.limit, total }).lastPage) ||
            null,
          permissions: permissions || [],
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },

    async createSupplier(_, payload) {
      try {
        const {
          data: { data },
        } = await http.post("supplier/save", payload);
        return data;
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
